import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBusiness = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 22,
	viewBox: "0 0 24 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2 15.6H10.8C10.14 15.6 9.6 15.06 9.6 14.4H1.212V19.2C1.212 20.52 2.292 21.6 3.612 21.6H20.4C21.72 21.6 22.8 20.52 22.8 19.2V14.4H14.4C14.4 15.06 13.86 15.6 13.2 15.6ZM21.6 4.8H16.8C16.8 2.148 14.652 0 12 0C9.348 0 7.2 2.148 7.2 4.8H2.4C1.08 4.8 0 5.88 0 7.2V10.8C0 12.132 1.068 13.2 2.4 13.2H9.6V12C9.6 11.34 10.14 10.8 10.8 10.8H13.2C13.86 10.8 14.4 11.34 14.4 12V13.2H21.6C22.92 13.2 24 12.12 24 10.8V7.2C24 5.88 22.92 4.8 21.6 4.8ZM9.6 4.8C9.6 3.48 10.68 2.4 12 2.4C13.32 2.4 14.4 3.48 14.4 4.8H9.588H9.6Z",
		fill: "currentColor"
	})
});
export default SvgIconBusiness;
